<template>
  <form @submit.prevent="$emit('submit')" class="fields-endpoint">
    <div class="flex flex-wrap md:flex-no-wrap md:gap-4">
      <div class="w-full">
        <div class="form-group" :class="{ '-has-error': errors.label.length > 0 }">
          <label for="label" class="label">Nome público</label>
          <input
            type="text"
            id="label"
            name="label"
            class="form-control"
            required
            :value="form.label"
            @input="updateFormField('label', $event.target.value)"
          >

          <p class="description" v-if="errors.label.length > 0">{{ errors.label[0] }}</p>
        </div>
      </div>
    </div>

    <div class="flex flex-wrap md:flex-no-wrap md:gap-4">
      <div class="w-full md:w-1/2">
        <div class="form-group" :class="{ '-has-error': errors.name.length > 0 }">
          <label for="name" class="label">Nome interno</label>
          <input
            type="text"
            id="name"
            name="name"
            class="form-control"
            required
            :value="form.name"
            @input="updateFormField('name', $event.target.value)"
          >
        </div>

        <p class="description" v-if="errors.name.length > 0">{{ errors.name[0] }}</p>
      </div>

      <div class="w-full md:w-1/2">
        <div class="form-group" :class="{ '-has-error': errors.path.length > 0 }">
          <label for="path" class="label">Path/URL</label>
          <input
            type="text"
            id="path"
            name="path"
            class="form-control"
            required
            :value="form.path"
            @input="updateFormField('path', $event.target.value)"
          >

          <p class="description" v-if="errors.path.length > 0">{{ errors.path[0] }}</p>
        </div>
      </div>
    </div>

    <div class="flex">
      <div class="w-full">
        <div class="form-group" :class="{ '-has-error': errors.tags.length > 0 }">
          <label class="label" for="tags">Tags</label>
          <multiselect
            :options="form.tags"
            :multiple="true"
            :taggable="true"
            :value="form.tags"
            label="name"
            track-by="name"
            class="form-control"
            id="tags"
            select-label="Pressione enter para selecionar"
            selected-label="Selecionado"
            deselect-label="Pressione enter para remover"
            placeholder="Selecione uma opção"
            tag-placeholder="Pressione enter para inserir"
            @tag="addTag"
            @remove="removeTag"
          >
            <span slot="noOptions">Lista vazia, escreva algo para adicionar.</span>
          </multiselect>

          <p class="description" v-if="errors.tags.length > 0">{{ errors.tags[0] }}</p>
        </div>
      </div>
    </div>

    <div class="flex">
      <div class="w-full">
        <div class="form-group flex" :class="{ '-has-error': errors.enable.length > 0 }">
          <div class="form-check">
            <input
              type="radio"
              class="form-check-input"
              id="enable-true"
              name="enable"
              :value="true"
              :checked="form.enable === true"
              @change="updateFormField('enable', true)"
            >
            <label for="enable-true" class="form-check-label">Habilitado</label>
          </div>

          <div class="form-check ml-2">
            <input
              type="radio"
              class="form-check-input"
              id="enable-false"
              name="enable"
              :value="false"
              :checked="form.enable === false"
              @change="updateFormField('enable', false)"
            >
            <label for="enable-false" class="form-check-label">Desabilitado</label>
          </div>

          <p class="description" v-if="errors.enable.length > 0">{{ errors.enable[0] }}</p>
        </div>
      </div>
    </div>

    <div class="flex">
      <div class="w-full">
        <div class="form-group" :class="{ '-has-error': errors.fields.length > 0 }">
          <label class="label" for="fields">Campos (JSON)</label>
          <v-jsoneditor
              :value="form.fields"
              @input="updateFormField('fields', $event)"
              :options="{ mode: 'code' }"
              :plus="false"
              height="400px"/>

          <p class="description" v-if="errors.fields.length > 0">{{ errors.fields[0] }}</p>
        </div>
      </div>
    </div>

    <div class="flex">
      <button class="btn btn-primary ml-auto" type="submit">{{ submitText }}</button>
    </div>
  </form>
</template>

<script>
import Multiselect from 'vue-multiselect';
import VJsoneditor from 'v-jsoneditor';

export default {
  name: 'FormEndpoint',

  props: {
    form: {
      required: true,
      type: Object,
    },

    errors: {
      required: true,
      type: Object,
    },

    submitText: {
      required: false,
      type: String,
      default: 'Salvar',
    },
  },

  model: {
    prop: 'form',
    event: 'input',
  },

  data() {
    return {
    };
  },

  methods: {
    /**
     * Update form field.
     *
     * @param field
     * @param value
     */
    updateFormField(field, value) {
      this.$emit('input', {
        ...this.form,
        [field]: value,
      });
    },

    /**
     * Add a tag in form.
     *
     * @param newTag
     */
    addTag(newTag) {
      this.$emit('input', {
        ...this.form,
        tags: [...this.form.tags, { name: newTag }],
      });
    },

    /**
     * Remove a tag in form.
     *
     * @param tagToRemove
     */
    removeTag(tagToRemove) {
      this.$emit('input', {
        ...this.form,
        tags: this.form.tags.filter((tag) => tag.name !== tagToRemove.name),
      });
    },
  },

  components: {
    Multiselect,
    VJsoneditor,
  },
};
</script>

<style lang="scss" scoped>

</style>
